import { Component } from '@angular/core';
import { SegmentedToggleOption } from '../../segmented-toggle/segmented-toggle.component';

@Component({
  selector: 'app-segmented-toggle-showcase',
  templateUrl: './segmented-toggle-showcase.component.html',
  styleUrls: ['./segmented-toggle-showcase.component.scss']
})
export class SegmentedToggleShowcaseComponent {
  selectedValue: string = 'month';
  selectedSort: string = 'asc';
  selectedView: string = 'list';

  optionsTimeframe: SegmentedToggleOption[] = [
    { label: 'Week', value: 'week' },
    { label: 'Month', value: 'month' },
    { label: 'Year', value: 'year' }
  ];

  optionsSort: SegmentedToggleOption[] = [
    { label: 'Ascending', value: 'asc' },
    { label: 'Descending', value: 'desc' }
  ];

  optionsView: SegmentedToggleOption[] = [
    { label: 'List View', value: 'list' },
    { label: 'Grid View', value: 'grid' },
    { label: 'Table View', value: 'table' }
  ];

  optionsBinary: SegmentedToggleOption[] = [
    { label: 'Off', value: false },
    { label: 'On', value: true }
  ];

  optionsWithIcons: SegmentedToggleOption[] = [
    { label: 'List', value: 'list', icon: 'format_list_bulleted' },
    { label: 'Grid', value: 'grid', icon: 'grid_3x3' },
    { label: 'Map', value: 'map', icon: 'map' }
  ];

  optionsIconOnly: SegmentedToggleOption[] = [
    { label: 'Dark', value: 'dark', icon: 'dark_mode' },
    { label: 'Light', value: 'light', icon: 'light_mode' }
  ];

  optionsWithCustomColors: SegmentedToggleOption[] = [
    { label: 'Success', value: 'success', icon: 'check_circle', iconColor: '#10B981' },
    { label: 'Error', value: 'error', icon: 'cancel', iconColor: '#EF4444' },
    { label: 'Warning', value: 'warning', icon: 'warning', iconColor: '#F59E0B' }
  ];

  optionsStatusColors: SegmentedToggleOption[] = [
    { label: 'Active', value: 'active', icon: 'check', iconColor: '#059669' },
    { label: 'Inactive', value: 'inactive', icon: 'block', iconColor: '#DC2626' }
  ];

  selectedViewMode: string = 'list';
  selectedTheme: string = 'dark';
  selectedStatus: string = 'success';
  selectedState: string = 'active';

  onValueChange(value: any, property: string): void {
    console.log(`${property} changed to:`, value);
  }
}
